import { render, staticRenderFns } from "./IdBlacklistDia.vue?vue&type=template&id=804e10b6&scoped=true"
import script from "./IdBlacklistDia.vue?vue&type=script&lang=js"
export * from "./IdBlacklistDia.vue?vue&type=script&lang=js"
import style0 from "./IdBlacklistDia.vue?vue&type=style&index=0&id=804e10b6&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804e10b6",
  null
  
)

export default component.exports